import { render, staticRenderFns } from "./afTable.vue?vue&type=template&id=4e52adde&scoped=true&"
import script from "./afTable.vue?vue&type=script&lang=js&"
export * from "./afTable.vue?vue&type=script&lang=js&"
import style0 from "./afTable.vue?vue&type=style&index=0&id=4e52adde&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e52adde",
  null
  
)

export default component.exports